<div class="row container-style mb-1" [hidden]="!isFormView">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-register-maintenance-order-supplies [maintenanceOrderContract]="maintenanceOrderModel"
      [maintenanceOrderSuppliesContract]="maintenanceOrderSuppliesModel" [disabled]="disabledActions"
      (updateListDetail)="getAllMaintenanceOrderSuppliesWithPagination()" (isFormView)="getFormView($event)">
    </app-register-maintenance-order-supplies>
  </div>
</div>
<div class="row container-style">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2 mb-1">
    <app-custom-button [title]="'Agregar Ins. Plan'" [label]="'Agregar Ins. Plan'" [icon]="'pi pi-sync'"
      [disabled]="(data!.items.length > 0 && haveArticleHomologous) || !disabledActions" [width]="'9rem'"
      [severity]="'success'" (onClick)="addSupplies()"></app-custom-button>

    <app-custom-button [title]="'Nuevo Insumo'" [label]="'Nuevo Insumo'" [icon]="'pi pi-plus'" [width]="'9rem'"
      [disabled]="!disabledActions" [severity]="'success'" (onClick)="newSupplies()"></app-custom-button>
    <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
      [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
      (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
    <app-custom-table [headers]="columns" [data]="data" [actions]="tableActions" [showCheckbox]="true"
      [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
      (onRecoverData)="getAllMaintenanceOrderSuppliesWithPagination()" (onPageChange)="onPageChange($event)"
      (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</div>